import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/admin/entrance','/store','/appDetails','/404','/appDownload','/apkDownload'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    if (to.path === '/admin/entrance') {
      next({ path: '/home' });
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => {
          const menus = res.data.menus;
          const permissionList = res.data.permissionList || [];
          const username = res.data.username;
          store.commit('SET_PERMISSION_LIST', permissionList);
          localStorage.setItem('username', username);
          store.dispatch('GenerateRoutes', { menus, username, roles: res.data.roles || [] }).then(() => {
            router.addRoutes(store.getters.addRouters);
            next({ ...to, replace: true });
          });
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            store.commit('CLEAR_PERMISSION');
            Message.error(err || 'Verification failed, please login again');
            next({ path: '/admin/entrance' });
          });
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/admin/entrance');
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js